import '@Application/Bootstrap';

import autoload from '@123/druid/dist/Framework/Decorators/Autoload';
import component from '@123/druid/dist/Framework/Decorators/Component';
import {inject} from '@123/druid/dist/Framework/Decorators/Inject';
import View from '@123/druid/dist/Framework/View/View';
import AidenAdvisorView from '@Component/Aiden/AidenAdvisorView';
import AnimateToAnchor from '@Component/AnimateToAnchor/AnimateToAnchor';
import type ElementList from '@Component/ElementList/ElementList';
import AlternativeButtonView from '../../Component/Recommendation/Button/AlternativeButtonView';

@autoload
@component
export default class ProductDetailsModuleView extends View {
    private elementList?: ElementList;

    constructor(@inject(AnimateToAnchor) animateToAnchor: AnimateToAnchor) {
        super();
        this.register(animateToAnchor);
    }

    protected mounted(): void {
        this.getViews(AidenAdvisorView);
        this.getViews(AlternativeButtonView);
        void this.el.queryRolePromise<ElementList>('product-details-button-element-list').then((elementList: ElementList) => {
            this.elementList = elementList;
            this.attachCallbacks();
            this.attachListeners();
        });
    }

    private attachCallbacks(): void {
        if (this.elementList === undefined) {
            return;
        }

        this.elementList.setCallbacks(
            (element: HTMLElement) => {
                element.classList.add('title--active');
            },
            (element: HTMLElement) => {
                element.classList.remove('title--active');
            },
        );
    }

    private attachListeners(): void {
        if (this.elementList === undefined) {
            return;
        }

        this.elementList.addEventListener('click', ((e: MouseEvent) => {
            this.elementList?.enableElement(e.target as HTMLElement, true, true);
        }) as EventListener);
    }
}
